/**
 * BackButton — bouton « Retour » partagé des pages longues (compte/aide/légal).
 *
 * UNE seule implémentation (icône ChevronLeft, style bordé transparent, a11y),
 * adoptée par FAQPage / NoticePage / SupportPage / LegalPageShell (remplace 3
 * boutons inline + 2 icônes ad hoc). Audit boutons retour, Vague B.
 *
 * Le LIBELLÉ est fourni par l'appelant (`label`) — D-LEGAL-EN-5 : les pages
 * in-shell passent `t('common.back')` (i18n global) ; LegalPageShell passe
 * `legalLabels[lang].back` (langue de l'URL). La CIBLE est injectée par la couche
 * routing (`onBack` → parent FIXE : /account in-shell, / public) ; le composant
 * ne décide JAMAIS la cible (pas de navigate(-1) ici).
 *
 * Rendu conditionnel : sans `onBack`, ne rend rien (préserve le comportement
 * historique des boutons bas conditionnels).
 *
 * @param position 'top' (en tête, marge basse) | 'bottom' (pied, marge haute).
 * @param color/borderColor — couleurs du thème de la page hôte (iso visuel).
 */
import React from 'react';
import { ChevronLeft } from 'lucide-react';

export default function BackButton({ onBack, label, color, borderColor, position = 'bottom' }) {
  if (!onBack) return null;
  return (
    <div style={position === 'top' ? { marginBottom: '14px' } : { marginTop: '16px' }}>
      <button
        type="button"
        onClick={onBack}
        aria-label={label}
        style={{
          padding: '10px 20px', borderRadius: '8px', border: `1px solid ${borderColor}`,
          background: 'transparent', color, cursor: 'pointer', fontSize: '14px',
          fontFamily: "'Inter', sans-serif", display: 'inline-flex', alignItems: 'center', gap: '6px',
        }}
      >
        <ChevronLeft size={14} strokeWidth={2.5} />
        {label}
      </button>
    </div>
  );
}
